import React from "react";
import { motion } from "framer-motion";
import { gallery } from "../data/contentData";

function GallerySection() {
  return (
    <section className="gallery-section">
      <div className="gallery-intro">
        <p className="kicker">A GLIMPSE OF JALSA</p>
        <h2>Dark rooms.<br /><i>Golden moments.</i></h2>
      </div>
      <div className="gallery-grid">
        {gallery.map((item, i) => (
          <motion.div
            className={`gallery-card ${item.className || ""}`}
            key={item.label}
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: i * 0.08 }}
          >
            <img src={item.image} alt={item.label} />
            <div className="gallery-label"><span>0{i + 1}</span>{item.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default GallerySection;
